import axios from "axios";
import { API_BASE_URL } from "../urls/urls";

const apiClient = axios.create({
  // baseURL: "http://localhost:5000/api",
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default apiClient;
